<div class="seccion-media">
  <h2>Admin </h2>
  <ul class="operaciones">
    <li>
      <h3>Librerías</h3>
      <button mat-raised-button>ver librerias</button>
      <button mat-raised-button>consignacion</button>
      <button mat-raised-button>nueva libreria</button>
      <button mat-raised-button>baja libreria</button>
      <button mat-raised-button>compra en firme</button>
    </li>
    <li>
      <h3>Prensa</h3>
      <button mat-raised-button>ver notas</button>
      <button mat-raised-button>nueva nota</button>
      <button mat-raised-button>ver agentes prensa</button>
      <button mat-raised-button>nuevo agente</button>
    </li>
    <li>
      <h3>Ventas</h3>
      <button mat-raised-button>ver ventas</button>
      <button mat-raised-button>venta directa</button>
      <button mat-raised-button>reclamo</button>
    </li>
    <li>
      <h3>Stock</h3>
      <button mat-raised-button>ver stock</button>
      <button mat-raised-button>ingresar nuevo</button>
      <button mat-raised-button>modificar</button>
    </li>
    <li>
      <h3>Libros</h3>
      <button mat-raised-button>ver libros</button>
      <button mat-raised-button>ejemplar de prensa</button>
      <button mat-raised-button>regalo</button>
      <button mat-raised-button>biblioteca</button>
    </li>
  </ul>
</div>